import { Errors, useApi } from '@equifinance/shared';

const apiPath = `${process.env.REACT_APP_BROKER_MANAGEMENT_API_AUTH_PATH}/`;

const apiUrl = (path: string) => `${apiPath}${path}`;

export type ChangePasswordPayload = {
  newPassword: string,
  existingPassword: string
}

export type ChangePasswordResponse = {
  id: string,
  emailAddress: string,
  newPassword: string,
  errors: Errors
}

const useChangePasswordApi = () => {
  const {
    post,
  } = useApi(apiUrl);

  return {
    postChangePassword: (payload: ChangePasswordPayload) => post('user/change-password', payload),
  };
};

export default useChangePasswordApi;
